export default __webpack_public_path__ + "assets/fonts/efbd5d20e407bbf85f2b3087ee67bfa1.eot";